import { tv } from '@change/ds-utils';

export const RectangleStyles = tv({
	base: 'h-[11px] w-[166px] bg-icon-inverse-disabled',
	variants: {
		loading: {
			true: 'animate-pulse',
			false: '',
		},
		rounded: {
			true: 'rounded-[28px]',
			false: '',
		},
	},
});
